document.addEventListener('DOMContentLoaded', function () {
    const siteMenus = document.querySelectorAll('[data-site-menu]');

    if (siteMenus.length === 0) return;

    function updateSiteMenuStickyState(siteMenu) {
        const siteMenuNavigation = siteMenu.querySelector('.site-menu-navigation');

        if (!siteMenuNavigation || window.innerWidth < 768) {
            siteMenu.classList.remove('site-menu--navigation-stuck');
            return;
        }

        if (siteMenuNavigation.getBoundingClientRect().top <= 15) {
            siteMenu.classList.add('site-menu--navigation-stuck');
            return;
        }

        siteMenu.classList.remove('site-menu--navigation-stuck');
    }

    function closeSiteMenu(siteMenu) {
        const siteMenuToggle = siteMenu.querySelector('[data-site-menu-toggle]');
        const siteMenuOverlay = siteMenu.querySelector('[data-site-menu-overlay]');

        if (!siteMenuToggle || !siteMenuOverlay) return;

        siteMenuToggle.setAttribute('aria-expanded', 'false');
        siteMenuToggle.setAttribute('aria-label', 'Open menu');
        siteMenuOverlay.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('has-site-menu-open');
    }

    function openSiteMenu(siteMenu) {
        const siteMenuToggle = siteMenu.querySelector('[data-site-menu-toggle]');
        const siteMenuOverlay = siteMenu.querySelector('[data-site-menu-overlay]');

        if (!siteMenuToggle || !siteMenuOverlay) return;

        siteMenuToggle.setAttribute('aria-expanded', 'true');
        siteMenuToggle.setAttribute('aria-label', 'Close menu');
        siteMenuOverlay.setAttribute('aria-hidden', 'false');
        document.body.classList.add('has-site-menu-open');
    }

    function setupSiteMenu(siteMenu) {
        const siteMenuToggle = siteMenu.querySelector('[data-site-menu-toggle]');
        const siteMenuLinks = siteMenu.querySelectorAll('.site-menu-overlay__link, .site-menu-overlay__button');

        if (!siteMenuToggle) return;

        siteMenuToggle.addEventListener('click', function () {
            if (siteMenuToggle.getAttribute('aria-expanded') === 'true') {
                closeSiteMenu(siteMenu);
                return;
            }

            openSiteMenu(siteMenu);
        });

        siteMenuLinks.forEach(function (siteMenuLink) {
            siteMenuLink.addEventListener('click', function () {
                closeSiteMenu(siteMenu);
            });
        });
    }

    siteMenus.forEach(setupSiteMenu);
    siteMenus.forEach(updateSiteMenuStickyState);

    document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;

        siteMenus.forEach(closeSiteMenu);
    });

    window.addEventListener('resize', function () {
        if (window.innerWidth >= 768) {
            siteMenus.forEach(closeSiteMenu);
        }

        siteMenus.forEach(updateSiteMenuStickyState);
    });

    window.addEventListener('scroll', function () {
        siteMenus.forEach(updateSiteMenuStickyState);
    });
});
